function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.4629 27.7656H53.7285V18.5371C53.7285 15.484 51.2445 13 48.1914 13H18.5371C15.484 13 13 15.484 13 18.5371V40.8086C13 43.2147 14.5429 45.2676 16.6914 46.0294V51.8828C16.6914 52.6293 17.1413 53.3022 17.831 53.5882C18.5208 53.8737 19.3143 53.7155 19.8421 53.1878L26.6846 46.3457H27.8887V63.0801C27.8887 66.1332 30.3727 68.6172 33.4258 68.6172H62.3154L69.1579 75.4593C69.6862 75.988 70.4802 76.1447 71.169 75.8596C71.8587 75.5737 72.3086 74.9007 72.3086 74.1543V68.3009C74.4571 67.5391 76 65.4862 76 63.0801V33.3027C76 30.2496 73.516 27.7656 70.4629 27.7656V27.7656ZM25.9199 42.6543C25.4306 42.6543 24.961 42.849 24.615 43.195L20.3828 47.4267V44.5C20.3828 43.4805 19.5566 42.6543 18.5371 42.6543C17.5196 42.6543 16.6914 41.8261 16.6914 40.8086V18.5371C16.6914 17.5196 17.5196 16.6914 18.5371 16.6914H48.1914C49.2089 16.6914 50.0371 17.5196 50.0371 18.5371V27.7656H33.4258C30.3727 27.7656 27.8887 30.2496 27.8887 33.3027V42.6543H25.9199ZM72.3086 63.0801C72.3086 64.0976 71.4804 64.9258 70.4629 64.9258C69.4434 64.9258 68.6172 65.752 68.6172 66.7715V69.6982L64.385 65.4665C64.039 65.1204 63.5699 64.9258 63.0801 64.9258H33.4258C32.4082 64.9258 31.5801 64.0976 31.5801 63.0801V33.3027C31.5801 32.2852 32.4082 31.457 33.4258 31.457H70.4629C71.4804 31.457 72.3086 32.2852 72.3086 33.3027V63.0801Z",
  fill: "#303440"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.5,
  cy: 47.5,
  r: 2.5,
  fill: "#7249E8"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 47.5,
  r: 2.5,
  fill: "#7249E8"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 61.5,
  cy: 47.5,
  r: 2.5,
  fill: "#7249E8"
});

var SvgComunication = function SvgComunication(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComunication, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comunication.8f3697ba.svg";
export { ForwardRef as ReactComponent };